import moment from 'moment';

export type Timeslot = {
  startTime: string;
  endTime: string;
  delayAfter?: number;
  dayNumber: number;
  visitDate: string;
};

export const isOverlapping = (timeslot: Timeslot, existingTimeslot: Timeslot) => {
  if (
    !timeslot?.startTime ||
    !timeslot?.endTime ||
    !existingTimeslot?.startTime ||
    !existingTimeslot?.endTime
  ) {
    return false;
  }

  const [timeslotStartHour, timeslotStartMinute] = timeslot.startTime.split(':');
  const [timeslotEndHour, timeslotEndMinute] = timeslot.endTime.split(':');

  const [existingTimeslotStartHour, existingTimeslotStartMinute] =
    existingTimeslot.startTime.split(':');

  const [existingTimeslotEndHour, existingTimeslotEndMinute] = existingTimeslot.endTime.split(':');

  const timeslotStart = moment(timeslot.visitDate)
    .set({ hour: Number(timeslotStartHour), minute: Number(timeslotStartMinute) })
    .add(timeslot.dayNumber, 'days');

  const timeslotEnd = moment(timeslot.visitDate)
    .set({ hour: Number(timeslotEndHour), minute: Number(timeslotEndMinute) })
    .add(timeslot.dayNumber, 'days')
    .add(timeslot?.delayAfter || 0, 'minutes');

  const existingTimeslotStart = moment(timeslot.visitDate)
    .set({ hour: Number(existingTimeslotStartHour), minute: Number(existingTimeslotStartMinute) })
    .add(existingTimeslot.dayNumber, 'days');

  const existingTimeslotEnd = moment(timeslot.visitDate)
    .set({ hour: Number(existingTimeslotEndHour), minute: Number(existingTimeslotEndMinute) })
    .add(existingTimeslot.dayNumber, 'days')
    .add(existingTimeslot.delayAfter || 0, 'minutes');

  return (
    timeslotStart.isSame(existingTimeslotStart) ||
    timeslotEnd.isSame(existingTimeslotEnd) ||
    timeslotStart.isBetween(existingTimeslotStart, existingTimeslotEnd) ||
    timeslotEnd.isBetween(existingTimeslotStart, existingTimeslotEnd) ||
    existingTimeslotStart.isBetween(timeslotStart, timeslotEnd) ||
    existingTimeslotEnd.isBetween(timeslotStart, timeslotEnd)
  );
};
